import styled from "@emotion/styled";
import { Stack, Typography } from "@mui/material";
import { Container } from "@/globalStyles";

export const PageWrapper = styled(Container)`
    padding-top: 24px;
    padding-bottom: 24px;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding-top: 16px;
        padding-bottom: 16px;
    }
`;

export const FormPaper = styled("form")`
    width: 100%;
`;

export const Actions = styled(Stack)`
    justify-content: flex-end;
    flex-wrap: wrap;
`;

export const Description = styled(Typography)`
    color: ${({ theme }) => theme.colors.text.secondary};
`;
